import styled from "styled-components";

export const Container = styled.span`
  .csc-cents {
    font-size: 0.75em;
  }
`;
